import { Link } from "react-router-dom";

interface BrandLogoProps {
  showText?: boolean;
}

export default function BrandLogo({ showText = false }: BrandLogoProps) {
  return (
    <Link
      to="/"
      className="flex items-center gap-2 select-none"
      aria-label="BPL News Home"
    >
      {/* Logo Image */}
      <div className="flex h-12 w-20 items-center justify-center rounded-lg">
        <img
          src={"/logo-1.png"}
          alt="BPL News Logo"
          className="h-12 w-20 object-contain"
          loading="eager"
        />
      </div>

      {/* Brand Text */}
      {showText && (
        <span className="font-display text-xl font-bold tracking-tight">
          BPL <span className="text-primary">News</span>
        </span>
      )}
    </Link>
  );
}
